import React from "react"

import PortletWithSplitContent from "@/components/PortletWithSplitContent"

import { colors } from "@/styles/colors"
import useStyles from "@/pages/InstanceChangedPage/styles"

import { Button, Grid, Typography } from "@material-ui/core"
import { Divider } from "@/components"
import ColorUtil from "@/utils/ColorUtil"
import LetalkLogo from "@/components/SVGComponents/LetalkLogo"
import useCustomStyles from "@/styles/custom"

const InstanceChangedPage: React.FC = () => {
	const classes = useStyles()
	const customClasses = useCustomStyles()

	return (
		<Grid
			container
			className={classes.container}
		>

			<Grid
				item
				className={classes.portlet}
			>
				<PortletWithSplitContent
					title={{
						value: "Instância alterada",
						logo: <LetalkLogo
							className={customClasses.logo}/>,
						...ColorUtil.getBackgroundAndContrastColor(colors.green[500])
					}}
					body={{
						...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
					}}
				>
					<Typography
						align="center"
						variant="subtitle1"
					>
						Você alterou a instância manualmente em outra guia, então mudamos para esta página automáticamente para evitar maiores confusões. Clique no botão abaixo se deseja ser redirecionado para a instância:
					</Typography>

					<Divider
						orientation="horizontal"
						size={3}
					/>

					<Button
						color="primary"
						variant="contained"
						type='submit'
						className={classes.goToLetalkButton}
						onClick={() => {
							window.open("/admin", "_self")
						}}
						fullWidth
					>
						Ir para a Letalk
					</Button>
				</PortletWithSplitContent>
			</Grid>
		</Grid>
	)
}

export default InstanceChangedPage
